<div [formGroup]="form">
	<ng-container *ngIf="data?.mode === 'add'">
		<div class="form-group">
			<label class="form-control-label" for="">Colaborador</label>

			<app-employee-info-display [employee]="data?.employee"></app-employee-info-display>
		</div>
	</ng-container>

	<div class="form-group">
		<label class="form-control-label" for="group">Turno</label>
		<select class="form-control cost-centers-options auto-grow-options" [disabled]="true">
			<option selected value="Turno {{ data?.employee?.timeShiftTitle ?? data?.employee?.shiftSchedule }}">
				Turno {{ data?.employee?.timeShiftTitle ?? data?.employee?.shiftSchedule }}
			</option>
		</select>
	</div>

	<div *ngIf="!isHidden('resignationReason')" class="form-group">
		<label class="form-control-label d-flex align-items-center gap-2" for="group">Motivo de desligamento
			<span class="info-icon-tooltip" ngbTooltip="Informação gerencial sobre o que motivou o desligamento."
				triggers="mouseenter:mouseleave" placement="top" container="body">
				<i [data-feather]="'info'"></i>
			</span>
		</label>
		<ng-select
			class="cost-centers-options auto-grow-options"
			[items]="lists.resignationTypesOptions"
			bindValue="label"
			placeholder="Motivo de desligamento"
			formControlName="resignationReason"
			[attr.title]="resignationReasonDescription"
			[loading]="isLoadingDismissalFields"
			[readonly]="isLoadingDismissalFields"
			loadingText="Carregando opções...">
			<ng-template ng-option-tmp let-item="item">
				<div [title]="item?.description">
					{{ item?.label }}
				</div>
			</ng-template>
		</ng-select>
		<app-error-msg [control]="form.controls['resignationReason']" [label]="'resignationReason'"></app-error-msg>
	</div>

	<div *ngIf="!isHidden('dismissalType')" class="form-group">
		<label class="form-control-label d-flex align-items-center gap-2" for="">Tipo de demissão
			<span class="info-icon-tooltip" ngbTooltip="Informação legal e de folha de pagamento do desligamento."
				triggers="mouseenter:mouseleave" placement="top" container="body">
				<i [data-feather]="'info'"></i>
			</span>
		</label>
		<ng-select
			class="cost-centers-options auto-grow-options"
			title="Tipo de demissão"
			[items]="lists.dismissalTypeOptions"
			bindValue="code"
			bindLabel="name"
			placeholder="Tipo de demissão"
			formControlName="dismissalType"
			[loading]="isLoadingDismissalFields"
			[readonly]="isLoadingDismissalFields"
			loadingText="Carregando opções...">
		</ng-select>
		<app-error-msg [control]="form.controls['dismissalType']" [label]="'dismissalType'"></app-error-msg>
	</div>

	<div *ngIf="!isHidden('expectedDate')" class="form-group">
		<label class="form-control-label" for="">Data prevista para o desligamento</label>
		<input type="date" class="form-control" formControlName="expectedDate" placeholder="Data prevista para o desligamento" />
		<app-error-msg [control]="form.controls['expectedDate']" [label]="'expectedDate'"></app-error-msg>
	</div>

	<div *ngIf="!isHidden('wasEmployeeInitiative')" class="form-group">
		<div class="d-flex gap-2 mb-small">
			<label class="form-control-label">Colaborador pediu para ser desligado:</label>
			<div class="custom-control custom-switch custom-switch-success">
				<input
					type="checkbox"
					class="custom-control-input"
					id="enableSwitchWasEmployeeInitiative"
					formControlName="wasEmployeeInitiative" />
				<label class="form-control-label" class="custom-control-label" for="enableSwitchWasEmployeeInitiative">
					<span class="switch-icon-left"><i data-feather="check"></i></span>
					<span class="switch-icon-right"><i data-feather="x"></i></span>
				</label>
			</div>
		</div>
	</div>

	<div *ngIf="!isHidden('vacancyReplacement')" class="form-group">
		<label class="form-control-label" for="group">Reposição de Vaga</label>
		<ng-select
			class="cost-centers-options auto-grow-options"
			title="Reposição de Vaga"
			[items]="lists.nextMovementTypesOptions"
			bindValue="value"
			bindLabel="label"
			placeholder="Reposição de Vaga"
			formControlName="vacancyReplacement">
		</ng-select>
	</div>

	<div class="form-group">
		<label class="form-control-label" for="">Justificativa</label>
		<textarea type="text" class="form-control" formControlName="note"></textarea>
		<app-error-msg [control]="form.controls['note']" [label]="'note'"></app-error-msg>
	</div>
</div>